import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
const _excluded = ["isRoot"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import { passListeners, passAttrs } from '../_use';
/**
 * svg内部id增加前缀，防止相同svg相互影响
 * @param {string} prefix 即count，自增id
 * @param {object} attr svg节点的属性对象
 * @returns
 */
const addPrefixAttr = (prefix, attr) => {
  const newAttr = {};
  for (const key in attr) {
    const value = attr[key];
    if (_startsWithInstanceProperty(value).call(value, 'url(#')) {
      const info = /url\(#(.*)\)/.exec(value);
      const id = (info === null || info === void 0 ? void 0 : info.length) && info[1];
      newAttr[key] = "url(#".concat(prefix, "_").concat(id, ")");
    } else if (key === 'id') {
      newAttr[key] = "".concat(prefix, "_").concat(value);
    } else if (key === 'xlink:href') {
      const id = value.replace('#', '');
      newAttr[key] = "#".concat(prefix, "_").concat(id);
    } else {
      newAttr[key] = value;
    }
  }
  return newAttr;
};
let count = 0; // 自增id

export function generate(node, key, rootProps, h) {
  var _context2;
  let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
    isRoot: true
  };
  if (!options.isRoot) {
    var _context;
    const attrs = passAttrs(options.isSvg ? addPrefixAttr(options.index, node.attributes) : node.attributes);
    return h(node.name, _objectSpread({
      key,
      class: node.attributes.class ? _reduceInstanceProperty(_context = [].concat(node.attributes.class)).call(_context, (acc, item) => {
        acc[item] = true;
        return acc;
      }, {}) : null
    }, attrs), (node.children || []).map((child, index) => {
      const {
          isRoot
        } = options,
        rest = _objectWithoutProperties(options, _excluded);
      return generate(child, "".concat(key, "-").concat(node.name, "-").concat(index), rootProps, h, _objectSpread({
        isRoot: false
      }, rest));
    }));
  }
  count = count + 1; // 自增id
  const attrs = passAttrs(_objectSpread(_objectSpread({}, rootProps.attrs), node.attributes));
  return h(node.name, _objectSpread(_objectSpread({
    key,
    class: node.attributes.class ? _reduceInstanceProperty(_context2 = [].concat(node.attributes.class)).call(_context2, (acc, item) => {
      acc[item] = true;
      return acc;
    }, {}) : null
  }, attrs), passListeners(rootProps.listeners)), (node.children || []).map((child, index) => {
    return generate(child, "".concat(key, "-").concat(node.name, "-").concat(index), rootProps, h, {
      isRoot: false,
      isSvg: node.name === 'svg',
      index: count
    });
  }));
}